import { Option } from '@vaaas/fpts/option';
import { shallowReactive } from 'vue';

export interface IReactivePaginated<T> {
    items: Array<T>;
    done: boolean;
    fetching: boolean;
    error: Option<Error>;
}

export abstract class ReactivePaginated<T> {
    private reactive: IReactivePaginated<T>;

    pending: Promise<any> | undefined;

    constructor(initial: Array<T>) {
        this.reactive = shallowReactive({
            items: initial,
            done: false,
            fetching: false,
            error: undefined,
        });
    }

    get items() { return this.reactive.items; }
    set items(x: Array<T>) { this.reactive.items = x; }

    get done() { return this.reactive.done; }
    set done(x: boolean) { this.reactive.done = x; }

    get fetching() { return this.reactive.fetching; }
    set fetching(x: boolean) { this.reactive.fetching = x; }

    get error() { return this.reactive.error; }
    set error(x: Option<Error>) { this.reactive.error = x; }

    abstract search(...xs: any[]): Promise<void>;

    abstract more(): Promise<void>;

    abstract cancel(): void;
}
